import { getUser, createUser, me, refreshToken, resendVerification, logout } from './authApi';

class AuthApi {
  async signIn(request) {
    const { email, password } = request;

    const { data } = await getUser(email, password);

    const accessToken = data.token;

    return { accessToken };
  }

  async signUp(request) {
    return await createUser(request);
  }

  async reenviarVerificacion(email) {
    return await resendVerification(email);
  }

  async me() {
    const { data } = await me();

    return {
      user_id: data.user_id,
      avatar: data.avatar,
      email: data.email,
      name: data.name,
      lastname: data.lastname,
      role_id: data.role_id,
      role: data.role,
      sub_role: data.sub_role,
      is_super: data.is_super,
      permissions: data.permissions || [],
    };
  }

  async refreshToken() {
    return await refreshToken();
  }

  async logout() {
    return await logout();
  }
}

export const authApi = new AuthApi();
